import React, { useState, useEffect } from "react";
import Typewriter from "typewriter-effect";
import "../styles/Home.css";
import image1 from "../images/dalle1.png";
import image2 from "../images/dalle2.png";
import image3 from "../images/dalle4.png";

function Home() {
  return (
    <div className="container">
      <div className="home one">
        <div className="left-container">
          <img className="home image one" src={image1} alt="Dalle1" />
          <h2 className="home text left">
            "monkey, ethereum,
            <br />
            cyborg laser eyes,
            <br />
            moon, space,
            <br />
            cosmos, stars,
            <br />
            detailed, glowing, <br />
            sci-fi, surreal, <br />
            dynamic, extraterrestrial,
            <br /> magical, neon"
          </h2>
        </div>
        <div className="center-container">
          <h1 className="home header one">PROMPTMEISTER</h1>
          <div className="home header two">
            <Typewriter
              options={{
                strings: [
                  "Own Your Imagination!",
                  "Proof of Prompt :)",
                  "Own Your Imagination!",
                  "Proof of Prompt :)",
                  "Own Your Imagination!",
                  "Proof of Prompt :)",
                  "Own Your Imagination!",
                  "Proof of Prompt :)",
                  "Own Your Imagination!",
                  "Proof of Prompt :)",
                  "Own Your Imagination!",
                  "Proof of Prompt :)",
                  "Still here?",
                  "What are you waiting for!?",
                  "Become a ^^^ ;)",
                  "Cook up some prompts!!!",
                ],
                autoStart: true,
                loop: true,
              }}
            />
          </div>
          <h2 className="home text middle">
            "Futuristic NYC
            <br /> with Neo-Tokyo lighting"
          </h2>
          <img className="home image three" src={image3} alt="Dalle3" />
        </div>
        <div className="right-container">
          <img className="home image two" src={image2} alt="Dalle2" />
          <h2 className="home text right">
            "an astronaut lounging
            <br /> in a tropical resort <br />
            in space, vaporwave"
          </h2>
        </div>
      </div>
    </div>
  );
}

export default Home;
